import styled from "@emotion/styled";
import {
  Box as MuiBox,
  Stack as MuiStack,
  styled as muiStyled,
  TableRow as MuiTableRow,
} from "@mui/material";
import { Button } from "components/Button";

export const Box = muiStyled(MuiBox)(
  () => `

`
);

export const TableRow = muiStyled(MuiTableRow)(
  ({ theme }) => `
    td {
      padding: 10px 0;
      color: #282828;
      border-bottom: 1px solid ${theme.palette.layout.line};
    }
    &:nth-of-type(odd) {
      td {
        background-color: ${theme.palette.bluegrey["100"]};
      }
    }
`
);

export const Stack = muiStyled(MuiStack)(
  ({ theme }) => `
  &.time-section {
    padding-top: 10px;
    font-size: 11px;
    line-height: 100%;
    vertical-align: middle;
    color: #3A3A3A ;
  }

  .divider-line {
    display: inline-block;
    width: 1px;
    height: 8px;
    background: ${theme.palette.grey["600"]};
    margin: 1px 2px 0;
  }

  .color-square {
    margin-right: 2px;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 1px;
  }
`
);

export const ButtonWrapper = styled(Button)`
  padding: 0;
`;

export const Memos = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const Memo = styled.div`
  display: flex;
  column-gap: 12px;
`;

export const MoreMemoButton = styled.span`
  color: #bbbbbb;
  cursor: pointer;
  text-align: left;
`;

export const Label = styled.label`
  font-weight: 700;
  white-space: nowrap;
`;

export const Contents = styled.div`
  max-height: 8em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  * {
    margin: 0;
  }
`;

export const Divider = styled.div`
  margin-left: 60px;
  border-bottom: 1px solid #efeff4;
`;

export const CustomerName = styled.div`
  word-break: break-all;
`;
